import priceCalculator from './price-calculator.json'

export default {
  ui: {
    priceCalculator
  }
}
